import { Loader2, ShieldCheck, ShieldAlert, Languages, Clock, CircleX, PauseCircle, StopCircle } from "lucide-react";

const MAP = {
  pending: { label: "Pending", cls: "bg-slate-100 text-slate-600 border-slate-200", icon: Clock },
  queued: { label: "Queued", cls: "bg-slate-100 text-slate-600 border-slate-200", icon: Clock },
  translating: { label: "Translating", cls: "bg-blue-50 text-blue-700 border-blue-200", icon: Languages, spin: false },
  verifying: { label: "Verifying", cls: "bg-amber-50 text-amber-700 border-amber-200", icon: Loader2, spin: true },
  paused: { label: "Paused", cls: "bg-slate-100 text-slate-700 border-slate-300", icon: PauseCircle },
  stopped: { label: "Stopped", cls: "bg-slate-100 text-slate-500 border-slate-200", icon: StopCircle },
  flagged: { label: "Flagged", cls: "bg-rose-50 text-rose-700 border-rose-200", icon: ShieldAlert },
  ready: { label: "EPUB Ready", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", icon: ShieldCheck },
  error: { label: "Error", cls: "bg-rose-50 text-rose-700 border-rose-200", icon: CircleX },
};

export function StatusBadge({ status }) {
  const cfg = MAP[status] || MAP.pending;
  const Icon = cfg.icon;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${cfg.cls}`}
    >
      <Icon className={`h-3.5 w-3.5 ${cfg.spin ? "spin-slow" : ""}`} />
      {cfg.label}
    </span>
  );
}
